import AnimatedArrow from '../../AnimatedArrow';

export default function PageFigureOverlay({ activeFigureHighlight, pageNum, pageRefs }) {
  if (!activeFigureHighlight || activeFigureHighlight.pageNumber !== pageNum) {
    return null;
  }

  const pageContainer = pageRefs.current[pageNum];
  const pageElement = pageContainer?.querySelector('.react-pdf__Page');
  if (!pageElement) return null;

  const rect = pageElement.getBoundingClientRect();

  const x = (activeFigureHighlight.x / 100) * rect.width;
  const y = (activeFigureHighlight.y / 100) * rect.height;
  const w = (activeFigureHighlight.width / 100) * rect.width;
  const h = (activeFigureHighlight.height / 100) * rect.height;

  return (
    <AnimatedArrow
      x={x}
      y={y}
      width={w}
      height={h}
    />
  );
}
